import React from 'react';
import { mask } from 'remask';
import { SharedPerson } from './types';
import {
  SharedWithList as StyledSharedWithList,
  SharedPersonItem,
  PersonInfo,
  PersonAvatar,
  PersonDetails,
  PersonName,
  PersonPhone,
  DeleteButton,
  DeleteIcon,
} from './styles';
import { useOnlineMode } from '../../../hooks/useOnlineMode';

interface SharedWithListProps {
  sharedWith: SharedPerson[];
  onRemovePerson: (personId: string) => void;
}

const SharedWithList: React.FC<SharedWithListProps> = ({
  sharedWith,
  onRemovePerson,
}) => {
  const { isOnline } = useOnlineMode();

  const getPersonInitials = (name: string): string => {
    return name
      .split(' ')
      .slice(0, 2)
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase();
  };

  const formatPhone = (phone: string): string => {
    const cleanPhone = phone.replace(/\D/g, '');
    return mask(cleanPhone, ['999.999.999-99', '(99) 99999-9999']);
  };

  if (sharedWith.length === 0) {
    return null;
  }

  return (
    <div>
      <StyledSharedWithList>
        {sharedWith.map((person) => (
          <SharedPersonItem key={person.id}>
            <PersonInfo>
              <PersonAvatar>
                {person.avatar ? (
                  <img src={person.avatar} alt={person.name} />
                ) : (
                  getPersonInitials(person.name)
                )}
              </PersonAvatar>
              <PersonDetails>
                <PersonName>{person.name}</PersonName>
                <PersonPhone>{formatPhone(person.phone)}</PersonPhone>
              </PersonDetails>
            </PersonInfo>
            {isOnline && (
              <DeleteButton
                onClick={() => onRemovePerson(person.id)}
                title={`Remover ${person.name} do compartilhamento`}
              >
                <DeleteIcon />
              </DeleteButton>
            )}
          </SharedPersonItem>
        ))}
      </StyledSharedWithList>
    </div>
  );
};

export default SharedWithList;
